<button class="retrieve-button"
    [ngClass]="(isGloballyLoading || disabled) ? 'hoverDisabled' : ''"
    [disabled]="isLoading || disabled || isGloballyLoading"
    type="submit"
    (click)="sendRequest()">

    <div class="button-content">
        <div *ngIf="isLoading" class="spinner-container"></div>
        <div *ngIf="!isLoading">
            <i class="{{ icon }}"></i>
        </div>
        <div *ngIf="text">{{ text }}</div>
    </div>

</button>